import { Component, Input, NgZone, OnInit, OnChanges, ViewChild } from '@angular/core';
import { take } from 'rxjs/operators';
import { GridComponent, GridDataResult, DataStateChangeEvent } from '@progress/kendo-angular-grid';
import { process, State } from '@progress/kendo-data-query';
import { NotificationService } from '../../services/notification.service';
import { OrderService} from '../../services/order.service';
import { SearchAuditHistory } from '../../models/models';

@Component({
    selector: 'customer-history-grid',
    templateUrl: './customer-history-grid.component.html',
    standalone: false
})
export class CustomerHistoryGrid implements OnInit, OnChanges {
    @Input() customerID: number = 0;
    @Input() refreshDate: Date = new Date();

    @ViewChild(GridComponent, { static: false }) public uiGrid!: GridComponent;

    public auditHistoryList: SearchAuditHistory[] = [];
    public isLoading: boolean = false;
    public gridState: State = { skip: 0, take: 10, sort: [{ dir: 'asc', field: 'abbrev' }] };
    public gridData: GridDataResult = { data: [], total: 0 };

    constructor(private orderService: OrderService,
        private notificationService: NotificationService, private ngZone: NgZone) {
    }

    ngOnInit() {
        //this.getAuditHistoryList();
        //console.log("ngOnInit");
    }

    ngOnChanges() {
        this.getAuditHistoryList();
        //console.log("ngOnChanges");
    }

    private getAuditHistoryList() {
        this.isLoading = true;
        this.auditHistoryList.length = 0;
        this.orderService.getAuditHistoryByCustomerID(this.customerID).subscribe(result => {
            this.isLoading = false;
            this.auditHistoryList = result.resultCollection;
            this.auditHistoryList = this.auditHistoryList.sort((left, right): number => {
                if (left.transactionDate < right.transactionDate) return 1;
                if (left.transactionDate > right.transactionDate) return -1;
                return 0;
            });
            this.setGrid();
            console.log("auditHistoryList:customerID", this.customerID, this.auditHistoryList.length);
        });
    }

    private setGrid() {
        this.gridData = process(this.auditHistoryList, this.gridState);
        this.fitColumns();
    }

    private fitColumns() {
        this.ngZone.onStable.asObservable().pipe(take(1)).subscribe(() => {
            if (this.uiGrid == null) return;
            this.uiGrid.autoFitColumns();
        });
    }

    public dataStateChange(state: DataStateChangeEvent): void {
        this.gridState = state;
        this.gridData = process(this.auditHistoryList, this.gridState);
    }
}
